import React from 'react';
import './sobrenos.css';

export default function SobreNos() {
    return (
        <div className="about-container">
            <header className="about-header">
                <h1>Sobre Nós</h1>
            </header>

            <main className="about-content">
                <section className="about-section">
                    <h2>Quem Somos</h2>
                    <div className="about-card">
                        <p>
                            A Guia Financeiro é uma plataforma dedicada a ajudar as pessoas a conquistarem sua independência financeira através de educação e planejamento. Nossa missão é empoderar nossos leitores com conhecimentos financeiros para que possam tomar decisões informadas e alcançar seus objetivos financeiros.
                        </p>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Nossa Missão e Visão</h2>
                    <div className="about-card">
                        <p>
                            <strong>Missão:</strong> Prover conteúdo de qualidade que ajude nossos leitores a entenderem e melhorarem suas finanças pessoais.
                        </p>
                        <p>
                            <strong>Visão:</strong> Ser a principal referência em educação financeira no Brasil, transformando vidas através do conhecimento.
                        </p>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Valores</h2>
                    <div className="about-card">
                        <ul className="about-list">
                            <li>Transparência</li>
                            <li>Educação</li>
                            <li>Integridade</li>
                            <li>Inovação</li>
                            <li>Empatia</li>
                        </ul>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Nossa História</h2>
                    <div className="about-card">
                        <p>
                            Fundada em 2024, a Guia Financeira nasceu com o objetivo de preencher a lacuna na educação financeira no Brasil. Desde então, temos crescido e alcançado milhares de leitores, oferecendo conteúdos ricos e estratégias práticas para gestão financeira.
                        </p>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Conheça Nossa Equipe</h2>
                    <div className="about-card">
                        <p>
                        Eu sou um profissional apaixonado por educação financeira, dedicado a trazer as melhores informações para os meus leitores. 
                        Com um trabalho focado em planejamento financeiro , ofereço conteúdo de qualidade para ajudar você a melhorar sua vida financeira.
                        </p>
                    </div>
                </section>

                <section className="about-section">
                    <h2>Contato</h2>
                    <div className="about-card contact">
                        <p>Se você tiver alguma dúvida ou quiser saber mais sobre nós, entre em contato conosco:</p>
                        <div className="contact-info">
                            <a href="mailto:felipedequadrosgomes18@gmail.com" className="email-link">
                                felipedequadrosgomes18@gmail.com
                            </a>
                            <p>São Paulo, SP</p>
                        </div>
                    </div>
                </section>
            </main>

        </div>
    );
}



